<template>
    <div id="contenedor-main-contratos-deducciones">
      <v-card
        flat>
        <v-card-text>
          <listado></listado>
        </v-card-text>
      </v-card>
    </div>
</template>

<script>
import Listado from './Listado.vue';

export default {
  name: 'MainContratoDeducciones',
  components: {
    Listado,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
